import { createUseStyles } from 'react-jss';
import { theme } from '@align-cpf/uikit-styles';

export default createUseStyles(
  {
    root: {
      position: 'relative',
    },

    inputLike: {
      cursor: 'pointer',
      position: 'relative',
      boxSizing: 'border-box',
      display: 'flex',
      outline: 'none',
      width: 180,
      height: 44,
      border: [1, 'solid', 'transparent'],
      padding: [theme.spacing.sp03, theme.spacing.sp04],
      background: theme.colors.backgroundSubtle01,
      borderRadius: 4,
      color: theme.colors.textPrimary,
      font: theme.typography.tpBody01,

      '&:hover': {
        '& $calendar': {
          color: theme.colors.textPrimary,
        },
      },

      '&:focus-visible': {
        borderColor: theme.colors.borderInteractive,

        '& $calendar': {
          color: theme.colors.textPrimary,
        },
      },
    },

    disabled: {
      color: theme.colors.textDisabled,
      cursor: 'default',

      '& $calendar': {
        color: theme.colors.iconDisabled,
      },

      '&:hover': {
        '& $calendar': {
          color: theme.colors.iconDisabled,
        },
      },

      '&:focus-visible': {
        '& $calendar': {
          color: theme.colors.iconDisabled,
        },
      },
    },

    invalid: {
      borderColor: theme.colors.borderError,
    },

    calendar: {
      position: 'absolute',
      right: theme.spacing.sp04,
      top: theme.spacing.sp03,
      color: theme.colors.iconTertiary,
    },

    popup: {
      position: 'absolute',
      left: 0,
      top: `calc(100% +  ${theme.spacing.sp01})`,
      background: theme.colors.backgroundMenu,
      // TODO: token
      boxShadow: '0px 2px 12px rgba(0, 0, 0, 0.125)',
    },
  },
  {
    name: 'DatePicker',
  },
);
